export enum ViewToggle {
  'dentistry' = 1,
  'cosmetology' = 2,
}
